import React, { useEffect, useState } from 'react'
import Select from 'react-select';


const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];

function OwnershipForm(props) {
    const [groupName, setGroupName] = useState('');
    const [groupDesc, setGroupDesc] = useState('');
    const [status, setStatus] = useState({});
    const [errors, setErrors] = useState({
        groupName: '',
        groupDesc: '',
        status: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            let data = {
                group_name: groupName,
                group_description: groupDesc,
                status_val: status?.value

            }
            await props.handleAction(data)
        }
    };

    const validateForm = () => {
        const newErrors = {
            groupName: '',
            groupDesc: '',
            status: ''
        };

        let isValid = true;

        if (!groupName.trim()) {
            newErrors.groupName = 'Group Name is required'; 
            isValid = false;
        }

        if (!groupDesc.trim()) {
            newErrors.groupDesc = 'Group Description is required'; 
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };


    useEffect(() => {
        if (props?.data) {
            let ppData = props?.data
            let status = statusOptions?.filter(e => e?.value === ppData?.status_val)
            setGroupName(ppData?.group_name)
            setGroupDesc(ppData?.group_description)
            setStatus(status?.[0])
        }
    }, [props])

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label className="form-label">Group Name:</label>
                <input type="text" className="form-control" value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                {errors.groupName && <div className="text-danger m-2">{errors.groupName}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Group Description:</label>
                <textarea className="form-control" value={groupDesc} onChange={(e) => setGroupDesc(e.target.value)} />
                {errors.groupDesc && <div className="text-danger m-2">{errors.groupDesc}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Status:</label>
                <Select options={statusOptions} onChange={(selectedOption) => setStatus(selectedOption)} value={status} />
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    )
}

export default OwnershipForm